import XAPPService from 'app/Core/services/XAPPService';
export const GET_CONTEUDOS = '{CONTEUDO APP] GET CONTEUDOS';
export const OPEN_CONTEUDO_DIALOG = '{CONTEUDO APP] OPEN CONTEUDO DIALOG';
export const ADD_CONTEUDO = '{CONTEUDO APP] ADD CONTEUDO';
export const CONTEUDO_WARNING = '{CONTEUDO APP] CONTEUDO WARNING';
export const CONTEUDO_INFO = '{CONTEUDO APP] CONTEUDO INFO';
export const CONTEUDO_ERROR = '{CONTEUDO APP] CONTEUDO ERROR';

const ListState = [
    'idconteudo',
    'titulo',
    'descricao',
    'grupo',
    'grupodescricao',
    'categoria',
    'categoriadescricao',
    'tipo',
    'tipodescricao',
    'statusregistro',
    'statusregistrodescricao'
];

const GetState = [
    'idconteudo',
    'titulo',
    'descricao',
    'conteudo',
    'grupo',
    'grupodescricao',
    'categoria',
    'categoriadescricao',
    'tipo',
    'tipodescricao',
    'statusregistro',
    'statusregistrodescricao'
];

export function list(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "conteudos", AActions, "spvwconteudo", ListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_CONTEUDOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: CONTEUDO_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ Campo: "conteudo.idconteudo", Operador: "=", Valor: _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "conteudos", AActions, "spvwconteudo", GetState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappRegisterAction(AActions, 'SEL')
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: OPEN_CONTEUDO_DIALOG,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: CONTEUDO_ERROR,
                    payload: error
                });
            });
    };
}

export function openDialog(_AValue = null) {
    return {
        type: OPEN_CONTEUDO_DIALOG,
        payload: _AValue
    }
}

export function save(_AValue, _AParams, _AAction) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "conteudo", _AAction, _AValue, "", AConditionsAND, AConditionsOR, 1);

        XAPPService.XappRegisterAction(AActions, "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: CONTEUDO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, { AND: [{ Campo: "tipo", Operador: "=", Valor: _AValue.tipo }] })))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: CONTEUDO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, { AND: [{ Campo: "tipo", Operador: "=", Valor: _AValue.tipo }] })))
                }
            }

            ).catch(error => {
                return dispatch({
                    type: CONTEUDO_ERROR,
                    payload: error
                });
            });
    };
}
